module.exports = __webpack_public_path__ + "media/scene_10.e79cfae2.mp3";